export default __webpack_public_path__ + "static/flag-de-60586eabafff8d9bc65e11b1102fb15b.svg";